import { getUserLikedVideos } from "../api";
import { useApiGet } from "@/hooks/useApi";

export function useGetUserLikedVideos(username) {
	const { data, isPending, isSuccess, isError, error } = useApiGet({
		key: ["liked", "course", "unit", "users", `${username}`],
		fn: () => getUserLikedVideos(username),
	});

	const { likedVideos } = data || { likedVideos: [] };

	return { likedVideos, isPending, isSuccess, isError, error };
}
